import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import FullScreenLoader from "./FullScreenLoader";

export default function PublicRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  if (loading) return <FullScreenLoader />;
  return user ? <Navigate to="/swiftreach/dashboard" replace /> : children;
}
